module.exports = __webpack_public_path__ + "static/media/JuliaSalzman.a849e315.jpg";